module.exports = __webpack_public_path__ + "static/media/Avatar7.d14fd955.svg";